// Copyright ©️ 2026 eVolve MEP, LLC

import { MARKUP_SIZE_MAX, MARKUP_SIZE_MIN } from 'components/Autodesk/extensions/MarkupModeExtension/constants';

import { NumberInput } from './NumberInput';

type SizeFieldProps = {
  id: string;
  label: string;
  value: string;
  unitOfMeasure?: string;
  min?: number;
  max?: number;
  step?: number;
};

export const SizeField = ({
  id,
  label,
  value,
  unitOfMeasure = 'pt',
  min = MARKUP_SIZE_MIN,
  max = MARKUP_SIZE_MAX,
  step = 1,
}: SizeFieldProps) => (
  <div className="field-wrapper">
    <label htmlFor={id}>{label}</label>
    <NumberInput id={id} unitOfMeasure={unitOfMeasure} min={min} max={max} step={step} defaultValue={value} />
  </div>
);
